import { Component } from '@angular/core';
import { CustomSocketComponent } from '../custom-socket/custom-socket.component';

@Component({
  selector: 'app-default-output-socket',
  imports: [],
  template: ``,
  styleUrl: './default-output-socket.component.scss',
})
export class DefaultOutputSocketComponent extends CustomSocketComponent {}
